<template>
  <div class="sf-pickup-service-info" v-if="realSFOrder && realSFOrder.length">
    <div class="header">顺丰上门取资料服务</div>
    <div class="content">
      <div class="info" :class="{'bottom-line': index !== realSFOrder.length - 1}" v-for="(info, index) in realSFOrder"
        :key="index">
        <div class="info-field">
          <div class="left-label">快递单号</div>
          <div class="right-content" v-text="info.tracking_number"></div>
        </div>
        <div class="info-field">
          <div class="left-label">快递状态</div>
          <div class="right-content" v-text="SFExpressStatus[info.status]"></div>
        </div>
        <div class="info-field">
          <div class="left-label">下单时间</div>
          <div class="right-content" v-text="info.sf_submit_time"></div>
        </div>
        <div class="info-field">
          <div class="left-label">寄件地址</div>
          <div class="right-content">
            <span>{{info.address.addressee}}</span>
            <span v-text="info.address.mobile_phone"></span>
            <span v-text="getAddress(pcds, info.address)"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SFService from '../../services/sf-service';
import addressUtils from '../../libs/address-utils';
import pcdService from '../../services/pcd-service';

export default {
  name: 'sfPickupServiceInfo',
  props: {
    order: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      pcds: {},
      SFExpressStatus: SFService.SFExpressStatus,
      getAddress: addressUtils.getAddress,
    };
  },
  created() {
    pcdService.getPcd().then(pcds => this.pcds = pcds).catch((e) => {
      if (e) console.log(e);
    });
  },
  computed: {
    realSFOrder() {
      if (!this.order.order_pickup || (this.order.order_pickup && this.order.order_pickup.length === 0)) {
        return [];
      }

      return this.order.order_pickup.filter(item => Boolean(item.tracking_number));
      // return this.order.order_pickup
    },
  },
};
</script>

<style lang="less" scoped>
.sf-pickup-service-info {
  margin-top: 15px;
  background-color: #fff;
  .header {
    padding: 15px 20px;
    font-size: 16px;
    line-height: 16px;
    color: #333;
    font-weight: 600;
  }
  .content {
    padding: 0 40px 1px 40px;
    .info {
      .info-field {
        margin: 14px 0;
        font-size: 14px;
        .left-label {
          float: left;
          width: 100px;
          color: #777;
        }
        .right-content {
          margin-left: 100px;
          color: #333;
        }
      }
      &.bottom-line {
        border-bottom: 1px solid #f0f0f0;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/order-detail/sf-pickup-service-info.vue